import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, Container, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import isEmail from 'validator/lib/isEmail';
import getRecaptchaToken from '../helpers/getRecaptchaToken';

import '../styles/AccountVerificationPage.css';
import AppContext from './context/AppContext';
import { bool } from 'prop-types';

const AccountVerificationPage = ({ isMobile }) => {
    const { appContext } = useContext(AppContext);
    const navigate = useNavigate();
    const [isValidRequest, setIsValidRequest] = useState(true);
    const [isConfirming, setIsConfirming] = useState(true);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [startVerification, setStartVerification] = useState(false);
    const [email, setEmail] = useState('');
    const handleVerificationRequest = useCallback(async () => {
        try {
            if (!email
                || !isEmail(email)) {
                setIsValidRequest(false);
                setIsConfirming(false);
                return;
            }
            setIsConfirming(true);
            setIsConfirmed(false);
            setErrorMessage(null);
            const response = await fetch(new URL('/api/user/verify', process.env.APP_URL), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    token: await getRecaptchaToken(appContext.config.recaptchaSiteKey),
                    email,
                }),
            });
            const data = await response.json();
            setIsConfirming(false);
            if (!data.success) {
                if (data.error) {
                    setErrorMessage(data.error);
                }
                setIsConfirmed(false);
                return;
            }
            setIsConfirmed(true);
        } catch (e) {
            setIsConfirming(false);
            setErrorMessage(e.message);
        }
    }, [email]);
    useEffect(() => {
        if (startVerification === true) {
            handleVerificationRequest();
        }
    }, [startVerification, handleVerificationRequest]);
    useEffect(() => {
        const navigateTimeoutFunc = () => {
            navigate('/');
        };
        const navigateTimer = null;
        const NAVIGATE_TIMEOUT_MS = 3000;
        if (isConfirmed === true) {
            setTimeout(navigateTimeoutFunc, NAVIGATE_TIMEOUT_MS);
        }
        return () => {
            clearTimeout(navigateTimer);
        };
    }, [isConfirmed]);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !isEmail(email)) 
            return;
        setStartVerification(true);
    };
    return (<Container
        fluid>
        <div
            className={'page--section mt-4'}>
            <h2>Verify Account</h2>
            {startVerification === false && (<>
                <Form
                    onSubmit={handleSubmit}>
                    <Form.Group
                        className={'mb-2'}
                        controlId={'accountVerificationForm.Email'}>
                        <Form.Label>Your email</Form.Label>
                        <Form.Control
                            style={{ maxWidth: '300px' }}
                            type={'text'}
                            name={'email'}
                            placeholder={'Enter your user email...'}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            isValid={isEmail(email)}
                            isInvalid={email !== '' && !isEmail(email)} />
                    </Form.Group>
                    <Form.Group
                        controlId={'accountVerificationForm.Submit'}>
                        <Button
                            type={'submit'}
                            onClick={handleSubmit}
                            disabled={!email || !isEmail(email)}>Submit</Button>
                    </Form.Group>
                </Form>
            </>)}
            {startVerification === true && (<>
                {!isValidRequest && (<p>Invalid verification request.</p>)}
                {isConfirming === true && (<p>Confirming request...</p>)}
                {(isConfirming === false && isConfirmed === false) && (<p>Request failed.</p>)}
                {isConfirmed === true && (
                    <p
                        style={{ color: 'green' }}>Your request has been received. Please check your email to continue with the process.</p>
                )}
                {(!isConfirming && errorMessage !== null) && (
                    <p
                        style={{ color: 'red' }}>Error: {errorMessage ?? 'Failed.'}</p>
                )}
            </>)}
        </div>
    </Container>);
};

AccountVerificationPage.propTypes = {
    isMobile: bool,
};

export default AccountVerificationPage;